import { forwardRef } from "react";
import { FormInput } from "./index";
import { DECIMAL_STEP } from "utils/decimals";

function NumericFormInput(
  { label, name, id = name, errors, controlProps, ...rest }, ref
) {
  return (
    <FormInput id={id} name={name}
               type="number"
               step={DECIMAL_STEP}
               onWheel={e => e.target.blur()}
               errors={errors} label={label}
               controlProps={controlProps} {...rest} ref={ref}  />
  );
}

export default forwardRef(NumericFormInput);
